import { render } from "./Arrow.vue?vue&type=template&id=107b76db"
const script = {}

import exportComponent from "/Users/umar/Desktop/umi-portfolio-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__